import { WlWindow } from 'typings/globals/cordova';
import {
  AbTestName,
  getExperimentById,
  getExperimentByName,
} from 'utils/abTests';

import { ActionType, Experiment } from './model';

declare const window: WlWindow;

export type ExperimentActions = {
  setExperimentVariant(experimentId: number, variant: number): void;
  assignExperimentVariant(experimentName: string): void;
  assignExperimentVariantFromUrl(experimentName: string): void;
};

function getRandom(min: number, max: number) {
  return Math.floor(Math.random() * (max - min) + min);
}

function getStoredExperiments(): Experiment[] {
  try {
    return JSON.parse(window.localStorage.getItem('ab-experiments')) || [];
  } catch (e) {
    return [];
  }
}

function checkIfExperimentAlreadyIsAssigned(experimentId: number) {
  const experiments = getStoredExperiments();
  return experiments.some((exp) => exp.id === experimentId);
}

function actionsFactory(
  dispatch: (action: ActionType) => void,
): ExperimentActions {
  return {
    setExperimentVariant(experimentId, variant) {
      const experiment = getExperimentById(experimentId);
      if (!experiment || !experiment.enabled) {
        return;
      }
      dispatch({
        type: 'SET_EXPERIMENT_VARIANT',
        payload: { variant, experimentId: experimentId },
      });
    },
    assignExperimentVariant(experimentName: AbTestName) {
      const experiment = getExperimentByName(experimentName);
      if (!experiment || !experiment.enabled) {
        return;
      }
      const isAlreadyAssigned = checkIfExperimentAlreadyIsAssigned(
        experiment.id,
      );
      if (isAlreadyAssigned) {
        return;
      }
      const variant = getRandom(0, experiment.variants.length);
      dispatch({
        type: 'SET_EXPERIMENT_VARIANT',
        payload: { variant, experimentId: experiment.id },
      });
    },
    assignExperimentVariantFromUrl(experimentName: AbTestName) {
      const experiment = getExperimentByName(experimentName);
      if (!experiment || !experiment.enabled) {
        return;
      }
      const isAlreadyAssigned = checkIfExperimentAlreadyIsAssigned(
        experiment.id,
      );
      if (isAlreadyAssigned) {
        return;
      }

      const variantFromQuery = new URLSearchParams(window.location.search).get(
        experiment.urlParam,
      );

      if (!variantFromQuery) {
        return;
      }

      let variant = parseInt(variantFromQuery, 10);

      variant = experiment.overrideVariant?.(variant) ?? variant;

      if (typeof variant === 'number') {
        dispatch({
          type: 'SET_EXPERIMENT_VARIANT',
          payload: { variant, experimentId: experiment.id },
        });
      }
    },
  };
}

export default actionsFactory;
